module.exports = __webpack_public_path__ + "static/media/portfolio-masonry-2.da80149e.jpg";